import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import Loading from '@/components/Loading.vue';

@Component({
	components: {
		Loading
	}
})
export default class MyButton extends Vue {
	@Prop() public disabled!: boolean;
	@Prop() public hidden!: boolean;
	@Prop() public caution!: boolean;
	@Prop() public title!: string;
	@Prop() public url!: string;

	public created(): void { }

	@Emit('click')
	public click() { }
	private onClick(): void {
		if (this.disabled) {
			return;
		}
		// urlが設定されている場合はリンク先を表示する
		if (this.url !== undefined && this.url.length > 0) {
			window.open(this.url, "_blank");
		} else {
		}
		this.click();
	}
}
